import { FastshiftRunbook } from "@wac-web/libraries/bxp-web-stargate-client/src/hook/use-bxp-web-stargate-client.types";
import { FormattedMessage } from "react-intl";

import { Stack } from "@atlaskit/primitives-next";

import { messages } from "./messages";
import {
    RunbookDateMetadata,
    RunbookProductMetadata
} from "./runbook-metadata";
import { RunbookStepList } from "./runbook-step-list";

export const RunbookDetailContent = ({
    runbook
}: {
    runbook: FastshiftRunbook;
}) => (
    <Stack space="space.200">
        <Stack space="space.050">
            <RunbookProductMetadata product={runbook.product} />
            {runbook.dueDate && (
                <RunbookDateMetadata
                    label={
                        <FormattedMessage
                            {...messages.runbooksPanelNextReviewLabel}
                        />
                    }
                    value={runbook.dueDate}
                />
            )}
            <RunbookDateMetadata
                label={
                    <FormattedMessage
                        {...messages.runbooksPanelCreatedAtLabel}
                    />
                }
                value={runbook.createdAt}
            />
            <RunbookDateMetadata
                label={
                    <FormattedMessage
                        {...messages.runbooksPanelModifiedAtLabel}
                    />
                }
                value={runbook.modifiedAt}
            />
        </Stack>
        <RunbookStepList steps={runbook.steps} />
    </Stack>
);
